// src/router.js
import { createRouter, createWebHistory } from 'vue-router'
import store from './store'
import ProjectPage from './components/ProjectPage.vue'
import TasksPage from './components/TasksPage.vue'
import TeamsPage from './components/TeamsPage.vue'
import DrawingsPage from './components/DrawingsPage.vue'
import ControllersPage from './components/ControllersPage.vue'
import DocumentsPage from './components/DocumentsPage.vue'
import ActivityPage from './components/ActivityPage.vue'

const routes = [
  { path: '/', redirect: '/project' },
  { path: '/project', name: 'Project', component: ProjectPage },
  { path: '/tasks', name: 'Tasks', component: TasksPage },
  { path: '/teams', name: 'Teams', component: TeamsPage },
  { path: '/drawings', name: 'Drawings', component: DrawingsPage },
  { path: '/documents', name: 'Documents', component: DocumentsPage },
  { path: '/controllers', name: 'Controllers', component: ControllersPage },
  { path: '/activity', name: 'Activity', component: ActivityPage },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
})

router.afterEach((to) => {
  store.dispatch('analytics/trackPage', {
    pageUrl: to.fullPath
  })
})

export default router